import { Avatar, Input, InputAdornment } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

import styles from './ChatPageV2.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import InputCustom from '../../components/atoms/input/InputCustom'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { useState } from 'react'
import { useEffect } from 'react'
import { updateGroup } from '../../features/groupSlice'

import DoneIcon from '@mui/icons-material/Done'

export const GroupInfo = ({
	handleClose,
	setNewChatType,
	setChatOption,
	chatOption,
	ChatMembersModalOpen,
	statusMap,
}) => {
	const dispatch = useDispatch()

	const currentSelectedGroup = useSelector(
		(s) => s.group.currentSelectedGroup
	)
	const groupMembers = useSelector((s) => s.group.groupMembers)
	const onlineUsers = useSelector((s) => s.auth.onlineUsers)

	const [groupName, setGroupName] = useState('')
	const [editingGroupName, setEditingGroupName] = useState(false)
	const [searchQuery, setSearchQuery] = useState('')

	const filtered = groupMembers.filter((m) =>
		(m.businessName || m.preferredName || `${m.firstName} ${m.lastName}`)
			.toLowerCase()
			.includes(searchQuery.toLowerCase().trim())
	)

	const handleSearchQueryChange = (e) => {
		setSearchQuery(e.target.value)
	}

	const handleUploadGroupProfilePic = (e) => {
		const file = e.target.files[0]
		if (!file) return
		const maxSizeMB = 4
		const maxSizeInBytes = maxSizeMB * 1024 * 1024

		if (file?.size > maxSizeInBytes) {
			return toastHelper(
				'Image size too large, please choose images less than 4mb',
				'error'
			)
		}

		if (file) {
            dispatch(
                updateGroup({
                    groupId: currentSelectedGroup._id,
                    data: {
                        containsImage: 'groupProfilePic',
                        image: file,
                    },
                })
            )
		}
	}

	const handleSetEditGroupName = () => {
		setEditingGroupName((prev) => !prev)
	}

	const handleChangeName = (e) => {
		setGroupName(e.target.value)
	}

	const handleSaveName = () => {
		dispatch(
			updateGroup({
				groupId: currentSelectedGroup._id,
				data: {
					name: groupName.trim(),
				},
			})
		)
	}

	const handleLeaveGroup = () => {
		setChatOption('leave')
	}

	useEffect(() => {
		setGroupName(currentSelectedGroup?.name || '')
	}, [currentSelectedGroup?.name])

	return (
		<aside
			className={`${styles.groupInfo} ${chatOption === 'view_group' ? styles.open : ''}`}
		>
			<div className={styles.chatListContainer}>
				<div className="">
					<div className={styles.groupInfoHeader}>
						<h4 className={styles.title}>Group Info</h4>
						<img
							src="/images/modal-close-icon.svg"
							alt="close"
							className={styles.close}
							onClick={handleClose}
							style={{ cursor: 'pointer' }}
						/>
					</div>
					<div className={styles.groupInfoDetailsMain}>
						<div>
							<label
								htmlFor="profileUpload"
								className={styles.uploadCircle}
							>
								<Avatar
									src={currentSelectedGroup?.groupProfilePic}
									sx={{
										width: '100%',
										height: '100%',
									}}
								/>
								<div className={styles.cameraIcon}>
									<img src="images/camera.svg" alt="" />
								</div>
							</label>
							<input
								id="profileUpload"
								type="file"
								accept=".jpg, .png"
								style={{ display: 'none' }}
								onChange={handleUploadGroupProfilePic}
							/>
						</div>
						<div className={styles.groupInfoDetails}>
							<Input
								disabled={!editingGroupName}
								value={groupName}
								endAdornment={
									<InputAdornment
										position="end"
										onClick={handleSetEditGroupName}
										sx={{
											cursor: 'pointer',
										}}
									>
										{editingGroupName ? (
											<DoneIcon
												sx={{
													color: '#7ca6bd',
												}}
												onClick={handleSaveName}
											/>
										) : (
											<img
												src="/images/edit-icon.svg"
												alt=""
											/>
										)}
									</InputAdornment>
								}
								sx={{
									fontSize: '1.25rem',
									fontWeight: 'bold',
									textAlign: 'center',
									'& .MuiInputBase-input.Mui-disabled': {
										color: 'black',
										WebkitTextFillColor: 'black',
									},
								}}
								disableUnderline={!editingGroupName}
								inputProps={{ maxLength: 30 }} 
								onChange={handleChangeName}
							/>
							<p>{groupMembers.length} Members</p>
						</div>
					</div>
					<div className={styles.groupSearchContainer}>
						<InputCustom
							value={searchQuery}
							type="text"
							name="search"
							id="search"
							placeholder="Search Members"
							error={false}
							searchIcon={true}
							onChange={handleSearchQueryChange}
						/>

						<ButtonCustom
							onClick={() => setNewChatType('group')}
							style={{ padding: '11px 11px' }}
						>
							<AddIcon
								sx={{
									width: '16px !important',
									height: '16px !important',
								}}
							/>
						</ButtonCustom>
					</div>
					<div>
						<ul
							className={`${styles.chatList} ${styles.chatListGroup}`}
						>
							{filtered?.slice(0, 5).map((friend) => (
								<li
									key={friend._id}
									className={styles.chatItem}
								>
									<div
										className={`${styles.avatar} ${statusMap[onlineUsers.includes(friend._id)]}`}
									>
										<Avatar
											src={friend.profilePic}
											alt="avatar"
											className={styles.avatar__img}
										/>
									</div>

									<div className={styles.chatInfo}>
										<h4 className={styles.userName}>
											{friend.businessName ||
												friend.preferredName ||
												`${friend.firstName} ${friend.lastName}`}
										</h4>
									</div>
								</li>
							))}

							{filtered.slice(5, filtered.length).length > 0 && (
								<ButtonCustom
									variant="link"
									onClick={ChatMembersModalOpen}
									style={{
										width: '100%',
										marginBottom: '4px',
									}}
								>
									<span
										style={{
											width: '100%',
											textAlign: 'start',
											color: 'var(--brand)',
										}}
									>
										+
										{
											filtered.slice(5, filtered.length)
												.length
										}{' '}
										Members
									</span>
								</ButtonCustom>
							)}
						</ul>
					</div>
				</div>
				<div className={styles.groupInfoActions}>
					<ButtonCustom
						variant="link"
						size="lg"
						style={{ width: '100%' }}
					>
						<span>
							<img src="/images/Mute-Notification.svg" alt="" />
							Mute Notification
						</span>
					</ButtonCustom>
					<ButtonCustom
						variant="link"
						size="lg"
						style={{ width: '100%' }}
						onClick={handleLeaveGroup}
					>
						<span>
							<img
								src="/images/curved-arrow-left-red.svg"
								alt="leave"
							/>
							Leave
						</span>
					</ButtonCustom>
				</div>
			</div>
		</aside>
	)
}
